import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../services/api';
import Spacing from '../Spacing';
import SectionHeading from '../SectionHeading';
import { pageTitle } from '../../helpers/PageTitle';

export default function ContactPage() {
  pageTitle('Contact Us - Ayumedix');
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm({ ...contactForm, [name]: value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axios.post(`${BASE_URL}/contact/`, contactForm);
      if (response.data.status === 201) {
        toast.success('Message sent successfully!');
        setContactForm({ name: '', email: '', mobile: '', message: '' });
      } else {
        toast.error('Failed to send message');
      }
    } catch (error) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cs_contact_page" id="contact">
      <ToastContainer />
      <Spacing lg="150" md="80" />
      <div className="container">
        <div className="text-center">
          <SectionHeading
            title="Get in touch for support"
            subTitle="Contact Us"
          />
        </div>
        <Spacing lg="75" md="60" />
        <div className="row">
          <div className="col-lg-5">
            <div className="cs_contact_info_wrap">
              <h2 className="cs_fs_40 cs_semibold">Ayumedix Healthcare</h2>
              <Spacing lg="30" md="20" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_22 cs_semibold">Operational Address:</h3>
                  <p>Gondal, Gujarat, 360311, India</p>
                </li>
                <li>
                  <h3 className="cs_fs_22 cs_semibold">Email Support:</h3>
                  <p>support@ayumedix.com</p>
                </li>
                <li>
                  <h3 className="cs_fs_22 cs_semibold">WhatsApp:</h3>
                  <p><a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>+91 93139 89270</a></p>
                </li>
                <li>
                  <h3 className="cs_fs_22 cs_semibold">Support Hours:</h3>
                  <p>Mon-Sat: 9 AM - 8 PM IST</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="cs_contact_form_wrap">
              <form className="cs_contact_form" onSubmit={handleContactSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="cs_fs_18 cs_semibold">Your full name</label>
                    <input
                      name="name"
                      value={contactForm.name}
                      onChange={handleContactChange}
                      placeholder="Enter name"
                      type="text"
                      className="cs_form_field"
                      required
                    />
                    <Spacing lg="20" md="20" />
                  </div>
                  <div className="col-lg-6">
                    <label className="cs_fs_18 cs_semibold">Email address</label>
                    <input
                      name="email"
                      value={contactForm.email}
                      onChange={handleContactChange}
                      placeholder="Enter email"
                      type="email"
                      className="cs_form_field"
                      required
                    />
                    <Spacing lg="20" md="20" />
                  </div>
                  <div className="col-lg-12">
                    <label className="cs_fs_18 cs_semibold">Phone number</label>
                    <input
                      name="mobile"
                      value={contactForm.mobile}
                      onChange={handleContactChange}
                      placeholder="Enter phone number"
                      type="tel"
                      className="cs_form_field"
                      required
                    />
                    <Spacing lg="20" md="20" />
                  </div>
                  <div className="col-lg-12">
                    <label className="cs_fs_18 cs_semibold">Your message</label>
                    <textarea 
                      name="message"
                      value={contactForm.message}
                      onChange={handleContactChange}
                      cols={30} 
                      rows={5} 
                      className="cs_form_field"
                      placeholder="How can we help you?"
                      required
                    />
                    <Spacing lg="30" md="30" />
                  </div>
                  <div className="col-lg-12">
                    <button type="submit" className="cs_btn cs_style_1" disabled={submitting}>
                      {submitting ? 'Sending...' : 'Send Message'}
                      {!submitting && (
                        <span>
                          <i><Icon icon="fa6-solid:arrow-right" /></i>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <style jsx>{`
        .cs_contact_page {
          background: #f8f8f8;
        }
        .cs_contact_info_wrap {
          background: #fff;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
        }
        .cs_contact_info li {
          list-style: none;
          margin-bottom: 25px;
        }
        .cs_contact_info li p {
          margin-bottom: 0;
          color: #666;
        }
        .cs_contact_form_wrap {
          background: #fff;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
        }
      `}</style>
    </div>
  );
}
